var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreasureHuntChest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 435,
    viewBox: "0 0 580 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3976 162.566H569.987V430.605C569.987 431.77 569.523 432.888 568.697 433.711C567.871 434.535 566.75 434.998 565.582 434.998H14.803C13.6346 434.998 12.5141 434.535 11.6879 433.711C10.8617 432.888 10.3976 431.77 10.3976 430.605V162.566Z",
    fill: "#FFD843"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M539.141 404.238V193.328L41.2358 193.328V404.238H539.141Z",
    fill: "#85403B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M467.173 113.137H290.191H113.205L10.3916 162.568H290.191H569.986L467.173 113.137Z",
    fill: "#FD9D0A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.626 113.137V153.782H48.9677L124.626 113.137Z",
    fill: "#441B1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M455.759 113.137V153.782H531.421L455.759 113.137Z",
    fill: "#441B1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M539.148 329.996H41.2421V338.782H539.148V329.996Z",
    fill: "#441B1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M539.148 258.777H41.2421V267.564H539.148V258.777Z",
    fill: "#441B1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M580 98.8764V158.592H2.42309e-05V98.8764C-0.00678422 89.1714 1.42123 79.5184 4.23801 70.2288C5.24154 66.8667 6.44186 63.5662 7.8328 60.3442C15.422 42.449 28.1316 27.1811 44.3732 16.4485C60.6149 5.71599 79.6682 -0.00518629 99.1521 3.52773e-06H480.857C500.335 0.0106701 519.379 5.73733 535.616 16.4663C551.853 27.1953 564.565 42.4521 572.167 60.3354C573.556 63.5581 574.757 66.8585 575.762 70.22C578.58 79.5124 580.008 89.1685 580 98.8764Z",
    fill: "#85403B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M575.781 70.2283H4.24329C5.24682 66.8662 6.44714 63.5657 7.83808 60.3438H572.168C573.563 63.5661 574.769 66.8665 575.781 70.2283Z",
    fill: "#441B1B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M543.492 22.2522H36.516C41.0848 18.5262 45.9797 15.2166 51.1419 12.3633H528.866C534.029 15.2166 538.923 18.5262 543.492 22.2522Z",
    fill: "#441B1B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M133.844 0H99.1432C44.3887 0 0 44.2653 0 98.8676V158.592H34.7012V98.8457C34.7012 44.2653 79.0899 0 133.844 0Z",
    fill: "#FFD843"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M446.142 0H480.843C535.598 0 579.964 44.2653 579.964 98.8676V158.592H545.267V98.8457C545.289 44.2653 500.888 0 446.142 0Z",
    fill: "#FFD843"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M545.296 123.992H34.7028V158.597H545.296V123.992Z",
    fill: "#FFD843"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.013 0H278.603C272.55 24.1623 272.656 123.979 272.656 123.979H306.961C306.961 123.979 307.057 24.1623 301.013 0Z",
    fill: "#FFD843"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.608 193.328H274.766V404.238H305.608V193.328Z",
    fill: "#FFD843"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasureHuntChest);
export default __webpack_public_path__ + "static/media/treasureHuntChest.fd0db9908472231cdfeb54d676a7f882.svg";
export { ForwardRef as ReactComponent };